import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Select } from '@mantine/core'
import LoadingData from '../../../../ui/LoadingData'
import { getOrderDocument } from '../../../../../services/orders'
import { updatePackageShipmentDocument } from '../../../../../services/package'
import { validation } from '../../../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const formValidation = {
  selectedDocumentId: {
    isError: false,
    message: ''
  },
}

const FormAdjustShippingDocument = ({ dataDocument, onCloseForm, reloadList }) => {
  const [loadingDocument, setLoadingDocument] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [documentList, setDocumentList] = useState([])
  const [selectedDocumentId, setSelectedDocumentId] = useState(null)
  const [validationForm, setValidationForm] = useState(formValidation)

  const submitShippingLabel = async (documentId) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      selectedDocumentId: documentId
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      order_id: dataDocument.order_id,
      documents: [documentId]
    }
    try {
      const response = await updatePackageShipmentDocument(dataDocument.id, payload)
      if (response.success) {
        onCloseForm()
        reloadList()
        notificationSuccess('Update Package Shipment Successfully', 'You have been updated data package shipment')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Package Shipment Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetDocumentsOrder = async (orderId) => {
    setLoadingDocument(true)
    try {
      const response = await getOrderDocument(orderId)
      if (response.success) {
        const dataDocument = response.data
        const remapDataDocument = dataDocument.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: val.attributes.name
          }
        })
        setDocumentList(remapDataDocument)
      } else {
        setDocumentList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingDocument(false)
    }
  }

  useEffect(() => {
    if (dataDocument !== null) {
      handleGetDocumentsOrder(dataDocument.order_id)
    }
  }, [dataDocument])

  const loadForm = () => {
    return (
      <Box>
        <Box mb='sm'>
          <Select
            name='selectedDocumentId'
            label='Choose Document'
            value={selectedDocumentId}
            data={documentList}
            onChange={setSelectedDocumentId}
            size='xs'
            error={validationForm.selectedDocumentId.isError ? `${validationForm.selectedDocumentId.message}` : ''}
            clearable
            allowDeselect={false}
          />
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
              <Button size='xs' variant="filled" loading={loadingForm} onClick={() => submitShippingLabel(selectedDocumentId)}>Submit</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingDocument ? <LoadingData /> : loadForm()}
    </Box>
    
  )
}

export default FormAdjustShippingDocument